import Skeleton from 'react-loading-skeleton';
import { Card, CardBody, CardFooter, Col, Row } from 'reactstrap';

const skeletonProps = {
  baseColor: '#e8e8e8c5',
  highlightColor: '#bababa96',
};

export const TeamListSkeleton = () => {
  return (
    <Row className="g-3 mb-4">
      {Array.from({ length: 6 }).map((_, index) => (
        <Col key={index} xs={12} md={4}>
          <Card className="h-100 border-0 shadow-sm">
            <CardBody>
              <div className="d-flex align-items-start gap-3">
                <Skeleton {...skeletonProps} circle width={72} height={72} />

                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between gap-2 mb-3">
                    <div className="flex-grow-1">
                      <Skeleton
                        {...skeletonProps}
                        style={{
                          height: '18px',
                          width: '70%',
                          marginBottom: '8px',
                        }}
                      />

                      <Skeleton
                        {...skeletonProps}
                        style={{
                          height: '14px',
                          width: '40%',
                        }}
                      />
                    </div>

                    <Skeleton
                      {...skeletonProps}
                      style={{
                        height: '20px',
                        width: '40px',
                      }}
                    />
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <Skeleton
                      {...skeletonProps}
                      style={{
                        height: '14px',
                        width: '60%',
                      }}
                    />

                    <Skeleton
                      {...skeletonProps}
                      style={{
                        height: '14px',
                        width: '40%',
                      }}
                    />
                  </div>
                </div>
              </div>
            </CardBody>

            <CardFooter className="bg-light-subtle border-top">
              <div className="d-flex justify-content-around text-center">
                {Array.from({ length: 4 }).map((_, item) => (
                  <div key={item}>
                    <Skeleton
                      {...skeletonProps}
                      style={{
                        height: '20px',
                        width: '20px',
                        margin: '0 auto 8px',
                      }}
                    />

                    <Skeleton
                      {...skeletonProps}
                      style={{
                        height: '16px',
                        width: '30px',
                        margin: '0 auto 4px',
                      }}
                    />

                    <Skeleton
                      {...skeletonProps}
                      style={{
                        height: '12px',
                        width: '50px',
                        margin: '0 auto',
                      }}
                    />
                  </div>
                ))}
              </div>
            </CardFooter>
          </Card>
        </Col>
      ))}
    </Row>
  );
};
